<template>
  <div>
    <div class="login-top">
      <div class="tips-register">
        <a href="/"  style="float: left">
          <van-icon name="revoke" />
          回到首页
        </a>
        <a href="//youcaiyun.com/Pages/Account/YCRegist.aspx" target="_blank">注册
          <van-icon name="arrow"/>
        </a>
      </div>
      <div class="logo-box">
        <img class="logo" src="@/assets/images/logo_1x.png"/>
        <div class="tips-welcome">
          欢迎使用优采云大数据服务平台，请登录~
        </div>
      </div>

    </div>
    <div class="login-box">
      <div class="tips-bar">
        登录
      </div>
      <div>
        <van-form @submit="onSubmit">
          <van-field
              v-model="form.account"
              :error-message="error.login_phone"
              :rules="[{ required: true, message: '手机号格式11位数字' }]"
              maxlength="11"
              name="account"
              placeholder="请填写已注册并认证后的手机号"
          />
          <van-field
              v-model="form.code"
              :rules="[{ required: true, message: '4-6位短信验证码' }]"
              maxlength="6 "
              name="code"
              placeholder="请填写短信验证码"
          >
            <template #button>
              <send-code :phone="form.account" @send-error="error_phone"></send-code>
            </template>
          </van-field>
          <van-field name="isRemember">
            <template #input>
              <van-checkbox v-model="isRemember" checked-color="#ee0a24" icon-size="14px">记住登录账号</van-checkbox>
            </template>
          </van-field>
          <div class="btn-box">
            <van-button :loading="load.login" block class="btn-login" loading-text="登录中..." native-type="submit" round
                        type="info">立即登录
            </van-button>
          </div>
        </van-form>
      </div>
      <div class="privacy">
        登录即同意优采云大数据平台
        <privacy></privacy>
      </div>

    </div>
  </div>
</template>
<style scoped>
.login-top {
  background: linear-gradient(130deg, #F35541 0%, #F62A3A 100%);
  height: 30vh;
  z-index: 0;
  position: relative;
}

.login-top::after {
  content: " ";
  display: block;
  height: 30vh;
  width: 100%;
  background: url("~@/assets/images/bg_login_icon.png") no-repeat;
  background-size: contain;
  background-position: right 5vh;
  position: absolute;
  top: 0;
  left: 0;
  z-index: -1;
}

.login-box {
  height: calc(100vh - 30vh + 30px);
  margin-top: -30px;
  border-top-left-radius: 20px;
  border-top-right-radius: 20px;
  z-index: 1;
  position: relative;
  background: #ffffff;
}

.login-top a {
  font-size: 14px;
  color: white;
  text-decoration: none;
}

.tips-register {
  padding: 20px;
  text-align: right;
}

.logo {
  width: 200px;
  object-fit: contain;
}

.logo-box {
  padding: 20px 0 20px 35px;
}

.tips-welcome {
  font-size: 12px;
  color: #ffffff;
  margin-top: 3px;
}

.tips-bar {
  text-align: center;
  padding: 20px 20px 30px;
  font-size: 18px;
  letter-spacing: 5px;
}

.btn-login {
  background: linear-gradient(130deg, #F35541 0%, #F62A3A 100%);
  border: 1px solid #F62A3A;
  letter-spacing: 1px;
}

.btn-box {
  margin: 40px 16px;
}

.privacy {
  font-size: 12px;
  color: rgba(207, 207, 207, 1);
  text-align: center;
}


</style>
<script>
import SendCode from "../components/SendCode";
import Privacy from "../components/Privacy";

export default {
  name: "Login",
  components: {Privacy, SendCode},
  metaInfo: {
    title: '请登录 @优采云大数据服务平台',
    htmlAttrs: {
      lang: 'zh-CN',
      keyword:'优采云，大数据，云服务，报告',
      amp: true
    }
  },
  data() {
    return {
      uri: this.$route.params.uri ?? '/',
      isRemember: false,
      code: '',
      show: {
        privacy: false
      },
      load: {
        login: false
      },
      form: {
        account: "",
        code: ""
      },
      error: {
        login_phone: ""
      }
    }
  },
  methods: {
    onSubmit(form) {
      this.load.login = true
      this.$axios.post(this.$apiconfg.login, form).then(({data}) => {
        if (data.code === 1) {
          this.$store.commit('Login', data.info)
          if (this.isRemember) {
            this.$store.commit('saveCode', this.form.account)
          } else {
            this.$store.commit('saveCode', "")
          }
          this.$router.replace(this.uri)

        }
        this.load.login = false
      }).catch(() => {
        this.load.login = false
      })
    },
    error_phone(msg) {
      this.error.login_phone = msg
    }
  },
  mounted() {
    if (this.$store.state.code.length > 8) {
      this.form.account = this.$store.state.code
      this.isRemember = true
    }
  }
}
</script>

